export enum DriverStatusEnum
{
    Delete = 0,
    Active = 1,
    Pending = 3,
    PendingVehicleConflict = 4
}